module.exports = __webpack_public_path__ + "static/media/image_7.a52b3245.png";